import type { ProductItemWithDetails } from "./grocyApi.ts";

export interface PantryItemForAI {
  name: string;
  daysUntilExpiry: number | null;
  amount: string; // human-readable, value + unit
  location: string;
}

const parseISO = (s?: string) => {
  if (!s) return null as Date | null;
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
};

const daysBetween = (a: Date, b: Date) => {
  const a0 = new Date(a); a0.setHours(0,0,0,0);
  const b0 = new Date(b); b0.setHours(0,0,0,0);
  return Math.floor((a0.getTime() - b0.getTime()) / 86400000);
};

export function computeDaysUntilExpiryClamped(best_before_date?: string): number | null {
  const today = new Date();
  const expiry = parseISO(best_before_date);
  if (!expiry) return null;
  const diff = daysBetween(expiry, today);
  const clamped = Math.max(0, diff);
  return clamped > 1000 ? null : clamped;
}

export function formatAmount(amount: number | undefined, unitName: string): string {
  const val = Number((Math.round((amount ?? 0) * 10) / 10).toFixed(1));
  return `${val} ${unitName}`;
}

export function buildPantryArray(stockItemsMap: Map<number, ProductItemWithDetails>): PantryItemForAI[] {
  const items = Array.from(stockItemsMap.values());
  const shaped = items.map(x => {
    const name = x.product.name;
    const daysUntil = computeDaysUntilExpiryClamped(x.stock.best_before_date);
    const sortDays = daysUntil === null ? Number.POSITIVE_INFINITY : daysUntil;
    return {
      name,
      daysUntilExpiry: daysUntil,
      amount: formatAmount(x.stock.amount, x.quantityUnit.name),
      location: x.location.name,
      _sortDays: sortDays,
    } as PantryItemForAI & { _sortDays: number };
  });
  shaped.sort((a, b) => a._sortDays - b._sortDays || a.name.localeCompare(b.name));
  return shaped.map(({ _sortDays, ...rest }) => rest);
}

